import { useEffect } from "react";
import { useAuth0, type User } from "@auth0/auth0-react";
import { config } from "config";
import { useUserRoles } from "contexts/UserRoles";
import { USERID_CLAIMS } from "system-constants";
import {
  initOpenReplay,
  setOpenReplayMetadata,
} from "shared/openreplay/openReplayClient";

function readUserId(user: User | undefined): string | undefined {
  const claim = user?.[USERID_CLAIMS];

  return typeof claim === "string" && claim !== "" ? claim : undefined;
}

export function useOpenReplayIdentity(): void {
  const { user } = useAuth0();
  const { roles } = useUserRoles();
  const userId = readUserId(user);
  const email = user?.email ?? "";
  const rolesText = roles.join(", ");

  useEffect(() => {
    if (userId === undefined) {
      return;
    }

    initOpenReplay(config, userId);
    setOpenReplayMetadata({ email, roles: rolesText });
  }, [userId, email, rolesText]);
}
